module.exports = __webpack_public_path__ + "media/images/viessmann_banner/banner_V2-82525522183e45d076443c212cfad742.png";